import { Level } from './../../../../const/dashboard';
import i18n from './../../../../i18n';
export const DEFAULT_STATUS = 'no_delete';
export const allCampaignSource = ['TTAM', 'Promote'];
export const TOGGLE_SWITCH_ON_OFF = 'common_switch';
export const SYSTEM_ORIGIN_MAP = {
  Promote: [51],
  TTAM: [100000],
  ALL: [100000, 51]
};
export const PERF_HEADER = {
  [Level.campaign]: 'module_campaign_edit_campaign_name',
  [Level.adgroup]: 'module_adgroup_edit_adgroup_name',
  [Level.ad]: 'module_creative_edit_ad_name',
  [Level.dashboard]: 'module_creative_edit_ad_name',
};
export const CHANGE_ACTION_TRACKING = {
  [Level.campaign]: 'ml_campaign_status_toggle_click',
  [Level.adgroup]: 'ml_ad_group_status_toggle_click',
  [Level.ad]: 'ml_ad_status_toggle_click',
  [Level.dashboard]: 'ml_ad_status_toggle_click',
};

export const CAMPAIGN_MORE_ACTION = {
  [Level.campaign]: 'ml_campaign_action_click',
  [Level.adgroup]: 'ml_ad_group_action_click',
  [Level.ad]: 'ml_ad_action_click',
  [Level.dashboard]: 'ml_ad_action_click',
};

export const EDIT_DYNAMIC_FIELD_KEYS = {
  [Level.campaign]: 'ml_campaign_edit_name_click',
  [Level.adgroup]: 'ml_ad_group_edit_name_click',
  [Level.ad]: 'ml_ad_edit_name_click',
  [Level.dashboard]: 'ml_ad_edit_name_click',
};

export interface CTA_OPTION {
  label: string;
  value: string;
  recommended?: boolean;
}

export interface CTA {
  id: string;
  key: string;
}

export const CTA_LIST: CTA[] = [
  {
    id: 'learn_more',
    key: i18n.t('module_fastcreation_creative_cta_learn_more') as string,
  },
  {
    id: 'download_now',
    key: i18n.t('module_fastcreation_creative_cta_download_now') as string,
  },
  {
    id: 'shop_now',
    key: i18n.t('module_fastcreation_creative_cta_shop_now') as string,
  },
  {
    id: 'sign_up',
    key: i18n.t('module_fastcreation_creative_cta_sign_up') as string,
  },
  {
    id: 'contact_us',
    key: i18n.t('module_fastcreation_creative_cta_contact_us') as string,
  },
  {
    id: 'apply_now',
    key: i18n.t('module_fastcreation_creative_cta_apply_now') as string,
  },
  {
    id: 'book_now',
    key: i18n.t('module_fastcreation_creative_cta_book_now') as string,
  },
  {
    id: 'play_game_cta',
    key: i18n.t('module_fastcreation_creative_cta_play_game') as string,
  },
];

export const RECOMMENDED_ACTION: CTA = CTA_LIST.filter(option => option.id === 'shop_now')[0];

export const DEFAULT_CTA_OPTIONS: CTA_OPTION[] = CTA_LIST.map(cta => ({
  label: cta.key,
  value: cta.id,
  recommended: cta.id === RECOMMENDED_ACTION.id,
}));

export const STARLING_KEYS = {
  ALL: i18n.t('common_all'),
};
